import { parametro_get_url } from "./urlBase"

const listar_tipos_documento = async ( padre ) => {

    try {

        const resp = await fetch( parametro_get_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': "*" },
            body: JSON.stringify({...padre})
        })
        const response = await resp.json()

        if ( response.Success ) {
            return response
        }
        else {
            console.log('parametroHelper', '20')
            throw response
        }

    } catch ( e ) {
        console.log('ubigeoHelper', '41')
        throw e
    }
}

const listar_tipos_inst_edu = async ( padre ) => {

    try {

        const resp = await fetch( parametro_get_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': "*" },
            body: JSON.stringify({...padre})
        })
        const response = await resp.json()

        if ( response.Success ) {
            return response
        }
        else {
            console.log('parametroHelper', '20')
            throw response
        }

    } catch ( e ) {
        console.log('ubigeoHelper', '41')
        throw e
    }
}

const listar_nacionalidades = async ( padre ) => {

    try {

        const resp = await fetch( parametro_get_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': "*" },
            body: JSON.stringify({...padre})
        })
        const response = await resp.json()

        if ( response.Success ) {
            return response
        }
        else {
            console.log('parametroHelper', '20')
            throw response
        }

    } catch ( e ) {
        console.log('ubigeoHelper', '41')
        throw e
    }
}

export {
    listar_tipos_documento,
    listar_tipos_inst_edu,
    listar_nacionalidades
}